import classNames from 'classnames';

import useIsMobile from '../../../hooks/useIsMobile';
import { MARKET_CAP_RADAR_INTERNAL_COLUMNS } from '../../MarketCapRadar.constants';

import styles from '../MarketCapRadarInternal.module.scss';

/** The company and the chart cells are drawn on their own - the rest are plain value bars. */
const VALUE_COLUMNS = MARKET_CAP_RADAR_INTERNAL_COLUMNS.slice(2);

const MarketCapRadarInternalSkeletonRow = () => {
  const { isMobile } = useIsMobile();

  const identity = (
    <>
      <div className={styles.skeletonLogo} />
      <div className={styles.skeletonTextBlock}>
        <div className={classNames(styles.skeletonLine, styles.skeletonLineShort)} />
        <div className={classNames(styles.skeletonLine, styles.skeletonLineLong)} />
      </div>
    </>
  );

  if (isMobile) {
    return (
      <div className={styles.mobileRow}>
        <div className={styles.mobileIdentity}>{identity}</div>
        <div className={styles.mobileChart}>
          <div className={styles.skeletonChart} />
        </div>
        <div className={styles.mobilePrices}>
          <div className={styles.skeletonLine} />
          <div className={styles.skeletonLine} />
        </div>
      </div>
    );
  }

  return (
    <div className={styles.tableRow}>
      <div className={styles.companyCell}>{identity}</div>
      <div className={styles.chartCell}>
        <div className={styles.skeletonChart} />
      </div>
      {VALUE_COLUMNS.map(column => (
        <div key={column.label} className={styles.cellValue}>
          <div className={styles.skeletonLine} />
        </div>
      ))}
    </div>
  );
};

export default MarketCapRadarInternalSkeletonRow;
